module.exports = __webpack_public_path__ + "static/media/plusIconOval.ca4e2cbe.svg";